<template>
  <div class="loginDiv">
    <!-- ============ Magic-link (passwordless) — WM ============ -->
    <div v-if="magicLinkEnabled">
      <form v-if="!breakGlass" ref="loginform" v-on:keyup.enter="sendMagicLink">
        <formentrystacked inputid="user" label="email" v-model="username" />
        <smallbutton @click="sendMagicLink()" toplabel="Send sign-in link"/>
        <div v-if="magicLinkSent" class="margin10">
          <label class="responsemessage">Check your email for a one-time sign-in link (valid 15 minutes).</label>
        </div>
      </form>

      <!-- Break-glass password (super-admins, e.g. if email is down) -->
      <form v-else ref="loginform" v-on:keyup.enter="breakGlassLogin">
        <formentrystacked inputid="user" label="email" v-model="username" />
        <formentrystacked inputid="pass" inputtype="password" label="password" v-model="password" />
        <smallbutton @click="breakGlassLogin()" toplabel="Login"/>
      </form>

      <div class="margin10">
        <linkbutton @click="breakGlass=!breakGlass"
          :toplabel="breakGlass ? 'Use a sign-in link instead' : 'Admin sign in with password'"/>
      </div>
    </div>

    <!-- ============ Legacy password login — other tenants ============ -->
    <div v-else>
      <form ref="loginform" v-on:keyup.enter="login">
        <formentrystacked inputid="user" label="email" v-model="username" />
        <formentrystacked inputid="pass" inputtype="password" label="password" v-model="password" />
        <smallbutton @click="login()" toplabel="Login"/>
      </form>
    </div>

    <div v-if="pleaseWait"><label class="pleasewaitlabel">Please Wait...</label></div>
    <div><label class="responsemessage">{{responseMessage}}</label></div>
  </div>
</template>

<script>
import {mapFields} from 'vuex-map-fields'
import datamethods from '../services/datamethods.js'
import securityhelper from '../services/securityhelper.js'
import formentrystacked from './controls/entry-stacked.vue'
import linkbutton from './controls/linkbutton.vue'
import smallbutton from './controls/button.vue'
import modal from './controls/modal.vue'
export default {
    name:'loginuser',
    mixins:[datamethods,securityhelper],
    components:{
        formentrystacked,
        linkbutton,
        smallbutton,
        modal,
    },
    computed:{
        ...mapFields([
            'pleaseWaitText',
            'isAdminUser',
            'loggedInUser',
            'loggedIn',
            'currentWallet',
            'username',
            'oldpassword',
            'currentNav',
            'password'
        ]),
        useAppSecurity(){
            if(window.USE_APP_SECURITY==undefined){return false}
            else{return window.USE_APP_SECURITY}
        },
        // Passwordless magic-link login is per-tenant (WM on). Other tenants keep the legacy
        // password login, since their magic-link endpoint returns "not enabled".
        magicLinkEnabled(){
            return window.ADMIN_MAGIC_LINK===true
        }
    },
    data(){
        return{
            newUserURL:window.NEW_USER_URL,
            newUserText:'Click here to create a new Account',
            pleaseWait:false,
            responseMessage:'',
            ischangepassword:false,
            magicLinkSent:false,
            breakGlass:false,
        }
    },
    mounted(){
        // A magic-link email lands on the admin app root with ?magiclink=<token>. Consume it on load.
        try{
            const params = new URLSearchParams(window.location.search)
            const token = params.get('magiclink')
            if(token){
                // Strip the token from the URL so a refresh doesn't re-attempt a consumed token.
                try{ window.history.replaceState({}, document.title, window.location.pathname) }catch(e){ /* non-fatal */ }
                this.verifyMagicLink(token)
            }
        }catch(e){ /* non-fatal */ }
    },
    methods:{
        // Grant admin access when the wallet is flagged admin, else reject and clear the form.
        applyAdminGate(){
            if(this.loggedInUser && this.loggedInUser.isAdmin){
                this.isAdminWallet=true
                this.currentNav="wallet"
                this.loggedIn=true
                return true
            }
            this.responseMessage = "This account is not authorized for admin access."
            this.username = ''
            this.password = ''
            return false
        },
        // Shared handling for any successful login response ({Successful, user, wallet, adminToken}).
        async handleLoginResponse(response){
            if(response && response.Successful){
                this.currentWallet = response.wallet
                this.loggedInUser = response.user
                this.AddUserToAPI(this.loggedInUser)
                if(response.adminToken){ this.AddAdminTokenToAPI(response.adminToken) }
                await this.loadEcommerceAdminConfig()
                return this.applyAdminGate()
            }
            this.responseMessage = (response && response.Message) ? response.Message : 'Sign-in failed.'
            return false
        },
        // ----- Magic-link (WM) -----
        async sendMagicLink(){
            if(this.username==''){ this.responseMessage='Please enter your email address'; return }
            this.pleaseWait=true; this.responseMessage=''
            var response = await this.callAPI({email:this.username},'adminmagiclink_request')
            this.magicLinkSent=true
            this.responseMessage = (response && response.Message) ? response.Message
                : 'If that email is a store admin, a sign-in link is on its way.'
            this.pleaseWait=false
        },
        async verifyMagicLink(token){
            this.pleaseWait=true; this.responseMessage='Signing you in...'
            var response = await this.callAPI({token:token},'adminmagiclink_verify')
            await this.handleLoginResponse(response)
            this.pleaseWait=false
        },
        async breakGlassLogin(){
            if(this.username=='' || this.password==''){return}
            this.pleaseWait=true; this.responseMessage=''
            var response = await this.callAPI({email:this.username,password:this.password},'adminloginhash')
            await this.handleLoginResponse(response)
            this.pleaseWait=false
        },
        // ----- Legacy password login (non-magic-link tenants) -----
        async login(){
            if(this.useAppSecurity){ this.securitylogin(); return; }
            if(this.username=="" || this.password==""){return}
            this.pleaseWait=true
            var response = await this.callAPI({email:this.username,password:this.password},'walletloginuser')
            await this.handleLoginResponse(response)
            this.pleaseWait=false
        },
        async post_login(token){
            if(this.useAppSecurity){ this.securitypost_login(token); return; }
            this.AddTokenToAPI(token)
            this.pleaseWait=true
            var response = await this.callAPI(null,'walletloginuser')
            await this.handleLoginResponse(response)
            this.pleaseWait=false
        },
    }
}
</script>

<style>
.loginDiv{
  margin-top:60px;
  grid-area: center;
  display:flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    font-size:large;
    height:70vh;
}
.margin10{
    margin:10px;
}
</style>
